import React, { Component } from 'react';

class AppHeader extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            headerClass: "app_header",
            spacingClass: false
        };
    }
    componentDidMount() {
        this.checkStatic();
    }
    componentWillReceiveProps() {
        this.checkStatic();
    }
    checkStatic() {
        let comparisonPage = window.location.href.split('#')[1].match(/^\/comparison\/$/ig);
        let overviewPage = window.location.href.split('#')[1].match(/^\/$/ig);
        if (comparisonPage || overviewPage) {
            this.setState({
                headerClass: "app_header app_header--sticky",
                spacingClass: true
            });
        } else {
            this.setState({
                headerClass: "app_header",
                spacingClass: false
            });
        }

    }

    render() {
        return (
            <React.Fragment>
                <div id="app-header-id" className={this.state.headerClass}>
                    {this.props.children}
                </div>
                {this.state.spacingClass &&
                    <div className="app_header--spacing-active"></div>
                }
            </React.Fragment>
        );
    }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/common/appheader/index.jsx